import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import Icon from './Icons';

const iconArea = '35px';

const Row = styled.div`
  display: grid;
  grid-template-columns: ${iconArea} 1fr;
  align-items: center;
  margin-left: -${iconArea};
  margin-right: -8px;
  padding-right: 8px;
  border: 1px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;

  &:hover {
    background: ${colors.sand};
    border: 1px solid ${colors.silt};
    border-radius: 3px;
    isolation: isolate;
  }

  &:not(:last-child) > *:not(:first-child) {
    border-bottom: 1px solid ${colors.sand};
  }

  & > .row-highlighter_icon {
    visibility: hidden;
  }

  &:hover > .row-highlighter_icon {
    visibility: visible;
  }
`;

const IconWrap = styled.div`
  width: ${iconArea};
  text-align: center;
`;

type RowHighlighterProps = {
  children: React.ReactNode;
  onRowClick: () => void;
  externalLink: string;
  externalLinkIcon: string;
};

const RowHighlighter = ({
  children,
  onRowClick,
  externalLink,
  externalLinkIcon,
}: RowHighlighterProps) => (
  <Row onClick={onRowClick}>
    <a
      href={externalLink}
      target="_blank"
      rel="noreferrer noopener"
      className="row-highlighter_icon"
    >
      <IconWrap>
        <Icon content={externalLinkIcon} />
      </IconWrap>
    </a>
    {children}
  </Row>
);

export default RowHighlighter;
